module.exports = __webpack_public_path__ + "img/filled-star.7dc6e5d5.svg";